<template>
  <div class="LiveList">
    <div class="zb-container">
      <h2 class="tab-title">
          <span class="ft">
              <a id="createZB" href="/account/myzb">我的直播</a>
          </span>
          <span class="tabs">
              <a :class="[tabView==0 ? 'cur' : '']" @click="showTab(0)">全部</a>
              <a :class="[tabView==1 ? 'cur' : '']" @click="showTab(1)">进行中/未开始的直播</a>
              <a :class="[tabView==2 ? 'cur' : '']" @click="showTab(2)">已结束的直播</a>
          </span>
      </h2>
      <div class="ZBlist" v-if="tabView==0">
          <div class="zbbox">
            <div class="zb-item" v-for="item in LiveList0" :key="item.id">
              <div class="img-left">
                <img :src="item.logo" class="logo">
              </div>
              <div class="info-right">    
                <span class="title p-span" :title="item.title" >{{item.title}}</span>     
                <span class="desc p-span" :title="item.content" style=" max-height: 66px;height:66px;">
                  <pre style="background:none; color:#999;
                    border: 0;    line-height: 21px;    font-family: '微软雅黑';    white-space: pre-line;    font-size: 14px;">{{item.content}}</pre>
                </span>   
                <!-- <span class="teacher p-span">{{item.presenter}}</span>     -->
                <span class="num p-span">
                  <span class="teacher p-span" style="display: inline-block;padding-right: 23px;">主讲人：{{item.presenter}} </span>
                  <img src="Images/user.jpg">
                  <span>{{item.scale}}人</span>  
                  <hr> 
                  <img src="Images/time.jpg">
                  <span>{{ item.startTimeS}} 至 {{item.endTimeS}}</span>
                </span>    
                <span class="opr p-span">
                  <button v-if='item.state ==2 && item.hasBackPlay==1 && item.allowPlayBack==1' class="finished" data-url="" @click="playback(item)">观看回放</button>
                  <button v-else-if='item.state ==2 && item.hasBackPlay==1 && item.allowPlayBack==0'>回放已禁</button>
                  <button v-else-if='item.state == 2 && item.hasBackPlay==0' >未录制回放</button>
                  <button v-else-if='item.state == 0 ' data-url="" @click="start(item)">未开始</button>
                  <button v-else  data-url="" @click="start(item)" class="start" >进入直播</button>
                </span> 
              </div>
            </div>
           </div>
          <div class="row ">
              <div class="col-md-12 loading-more loading-more-1" v-if="query_data[0].PageIndex*query_data[0].MaxResultCount< query_data[0].totalCount" style="background:#fff" @click="loadall()">加载更多</div>
          </div>
      </div>
      <div class="ZBlist" v-if="tabView==1">
          <div class="zbbox">
            <div class="zb-item" v-for="item in LiveList1" :key="item.id">
              <div class="img-left">
                <img :src="item.logo" class="logo">
              </div>
              <div class="info-right">    
                <span class="title p-span" :title="item.title">{{item.title}}</span>     
                <span class="desc p-span" :title="item.content" style=" max-height: 66px;height:66px;">
                    <pre style="background:none; color:#999;
                    border: 0;    line-height: 21px;    font-family: '微软雅黑';    white-space: pre-line;    font-size: 14px;">{{item.content}}</pre>
                  </span>   
               
                <span class="num p-span">
                  <span class="teacher p-span" style="display: inline-block;padding-right: 23px;">主讲人：{{item.presenter}} </span>
                  <img src="Images/user.jpg">
                  <span>{{item.scale}}人</span>  
                  <hr> 
                  <img src="Images/time.jpg">
                  <span>{{ item.startTimeS}} 至 {{item.endTimeS}}</span>
                </span>    
                <span class="opr p-span">
                 <button v-if='item.state ==2 && item.hasBackPlay==1 && item.allowPlayBack==1' class="finished" data-url="" @click="playback(item)">观看回放</button>
                  <button v-else-if='item.state ==2 && item.hasBackPlay==1 && item.allowPlayBack==0'>回放已禁</button>
                  <button v-else-if='item.state == 2 && item.hasBackPlay==0' >未录制回放</button>
                  <button v-else-if='item.state == 0 ' data-url="" @click="start(item)">未开始</button>
                  <button v-else  data-url="" @click="start(item)" class="start" >进入直播</button>
                </span> 
              </div>
            </div>
          </div>
          <div class="row ">
              <div class="col-md-12 loading-more loading-more-2" v-if="query_data[1].PageIndex*query_data[1].MaxResultCount< query_data[1].totalCount" style="background:#fff"  @click="loadUnend()">加载更多</div>
          </div>
      </div>
      <div class="ZBlist" v-if="tabView==2">
          <div class="zbbox">
            <div class="zb-item" v-for="item in LiveList2" :key="item.id" >
              <div class="img-left">
                <img :src="item.logo" class="logo">
              </div>
              <div class="info-right">    
                <span class="title p-span" :title="item.title">{{item.title}}</span>     
                <span class="desc p-span" :title="item.content" style=" max-height: 66px;height:66px;">
                    <pre style="background:none; color:#999;
                    border: 0;    line-height: 21px;    font-family: '微软雅黑';    white-space: pre-line;    font-size: 14px;">{{item.content}}</pre>
                  </span>   
                <!-- <span class="teacher p-span">{{item.presenter}}</span>     -->
                <span class="num p-span">
                  <span class="teacher p-span" style="display: inline-block;padding-right: 23px;">主讲人：{{item.presenter}} </span>
                  <img src="Images/user.jpg">
                  <span>{{item.scale}}人</span>  
                  <hr> 
                  <img src="Images/time.jpg">
                  <span>{{ item.startTimeS}} 至 {{item.endTimeS}}</span>
                </span>    
                <span class="opr p-span">
                  <button v-if='item.state ==2 && item.hasBackPlay==1 && item.allowPlayBack==1' class="finished" data-url="" @click="playback(item)">观看回放</button>
                  <button v-else-if='item.state ==2 && item.hasBackPlay==1 && item.allowPlayBack==0'>回放已禁</button>
                  <button v-else-if='item.state == 2 && item.hasBackPlay==0' >未录制回放</button>
                  <button v-else-if='item.state == 0 ' data-url="" @click="start(item)">未开始</button>
                  <button v-else  data-url="" @click="start(item)" class="start" >进入直播</button>
                </span> 
              </div>
            </div>
          </div>
          <div class="row ">
              <div class="col-md-12 loading-more loading-more-3"  v-if="query_data[2].PageIndex*query_data[2].MaxResultCount< query_data[2].totalCount" style="background:#fff"  @click="loadEnd()">加载更多</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import comFun from "@/common/common";
export default {
  name: "LiveList",
  data() {
    return {
      tabView:0,
      showFabu:false, // 下载客户端的弹框
      LiveList0:[],
      LiveList1:[],
      LiveList2:[],
      query_data:[
        { stopajax: !1, MaxResultCount:5, PageIndex: 0,SkipCount:0, totalCount: 0, index: 0 }, //全部
        { stopajax: !1, MaxResultCount:5, PageIndex: 0,SkipCount:0, totalCount: 0, index: 1 ,IsEnd:false}, // 未开始/进行中
        { stopajax: !1, MaxResultCount:5, PageIndex: 0,SkipCount:0, totalCount: 0, index: 2 ,IsEnd:true}   // 已结束
      ]
    };
  },
  mounted() {
    // console.log(this.$store)
    this.loadall()
    this.loadUnend()
    this.loadEnd()
  },
  filters: {
   dateFormat: function (dateStr, pattern = '') {
    
      var dt = new Date(dateStr)
      var yy = dt.getFullYear()
      var mm = (dt.getMonth() + 1).toString().padStart(2, '0')
      var dd = dt.getDate().toString().padStart(2, '0')
      var h = dt.getHours().toString().padStart(2, '0')
      var m = dt.getMinutes().toString().padStart(2, '0')
      var s = dt.getSeconds().toString().padStart(2, '0')
      if (pattern.toLowerCase() === 'YYYY-MM-DD') {
        return yy + '-' + mm + '-' + dd
      } else if(pattern.toLowerCase() === 'yyyy-mm-dd hh:mm'){
        return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m 
      } else if(pattern.toLowerCase() === 'hh:mm'){
        return  h + ':' + m 
      }else {
        return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + s
      }
    }
  },
  computed: {
  },
  methods: {
    showTab(i){
     this.tabView = i  
    },
    loadall:  function(){ // 获取全部
      comFun.getLiveList(this.query_data[0]).then(res=>{
        this.LiveList0 = this.LiveList0.concat(res.result.items)
        this.query_data[0].totalCount = res.result.totalCount
        if(this.query_data[0].PageIndex*this.query_data[0].MaxResultCount< this.query_data[0].totalCount){
          this.query_data[0].PageIndex++
        } else{
          this.query_data[0].stopajax = 1 
        }
      }) 
    },
    loadUnend:  function(){ // 未结束
      comFun.getLiveList(this.query_data[1]).then(res=>{
         this.LiveList1 = this.LiveList1.concat(res.result.items)
        this.query_data[1].totalCount = res.result.totalCount
        if(this.query_data[1].PageIndex*this.query_data[1].MaxResultCount< this.query_data[1].totalCount){
          this.query_data[1].PageIndex++
        } else{
          this.query_data[1].stopajax = 1 
        }
      }) 
    },
    loadEnd: function(){ // 已结束
      comFun.getLiveList(this.query_data[2]).then(res=>{
        this.LiveList2 = this.LiveList2.concat(res.result.items)
        this.query_data[2].totalCount = res.result.totalCount
        if(this.query_data[2].PageIndex*this.query_data[2].MaxResultCount< this.query_data[2].totalCount){
          this.query_data[2].PageIndex++
        } else{
          this.query_data[2].stopajax = 1 
        }
      }) 
    },
    start(item){
      comFun.start(item)
    },
    playback(item){
      comFun.playback(item)
    }
    // getBackurl(item){
    //    this.getBack(item).then(res=>{
    //    item.play_url= res
    //   }) 
    // },
    // getBack(item){
    //   var postdata = {
    //       Title: item.title,
    //       Start: item.startDate,
    //       End: item.endDate,
    //       room_id: item.room_id,
    //       Type: 2
    //   }
    //   return new Promise((resolve, reject) => {
    //         this.$api.post('/api/zbtest/PlayBack',postdata, Response => {
    //           resolve(Response.result.data.list[0].play_url)
    //         },error=>{
    //           reject(error)
    //         })
    //   }) 
    // }
  }
}
</script>


